import ExcelJS from "exceljs";
import { influencerPaymentStatusLabel } from "./influencerPaymentStatus";
import { parseApiAmount } from "./amountFormat";

const getGenderLabel = (gender) => {
  if (gender === "male") return "남성";
  if (gender === "female") return "여성";
  return gender ?? "";
};

const getPlatformLabel = (item) => {
  const platforms = [];

  if (item?.tiktok_influencer_id) platforms.push("TikTok");
  if (item?.instagram_influencer_id) platforms.push("Instagram");
  if (item?.youtube_influencer_id) platforms.push("YouTube");

  return platforms.join(", ");
};

export async function createSettlementExcel(data, fileName = "정산내역.xlsx") {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("정산현황");
  const rows = Array.isArray(data) ? data : (data?.result ?? []);

  worksheet.columns = [
    { header: "수령자 ID", key: "payee_user_id", width: 38 },
    { header: "닉네임", key: "nickname", width: 18 },
    { header: "성별", key: "gender", width: 12 },
    { header: "인증된 플랫폼", key: "platform", width: 20 },
    { header: "정산 금액", key: "settlement_amount", width: 14 },
    { header: "세금 금액", key: "tax_amount", width: 14 },
    { header: "실지급액", key: "net_amount", width: 14 },
    { header: "통화", key: "currency", width: 10 },
    { header: "상태", key: "status", width: 18 },
    { header: "지급일", key: "paid_at", width: 20 },
  ];

  rows.forEach((item) => {
    worksheet.addRow({
      payee_user_id: item.payee_user_id ?? "",
      nickname: item.nickname ?? "",
      gender: getGenderLabel(item.gender),
      platform: getPlatformLabel(item),
      settlement_amount: parseApiAmount(item.settlement_amount),
      tax_amount: parseApiAmount(item.tax_amount),
      net_amount: parseApiAmount(item.net_amount),
      currency: item.currency ?? "KRW",
      status: influencerPaymentStatusLabel(item.status),
      paid_at: item.paid_at ?? "",
    });
  });

  worksheet.autoFilter = {
    from: "A1",
    to: "J1",
  };

  worksheet.eachRow((row, rowNumber) => {
    row.eachCell((cell, colNumber) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
      cell.alignment = {
        vertical: "middle",
        horizontal: "center",
      };

      // 금액 컬럼만 오른쪽 정렬
      if ([5, 6, 7].includes(colNumber) && rowNumber !== 1) {
        cell.alignment = {
          vertical: "middle",
          horizontal: "right",
        };
      }

      if (rowNumber === 1) {
        cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF1F2937" },
        };
      }
    });
  });

  ["E", "F", "G"].forEach((columnKey) => {
    worksheet.getColumn(columnKey).numFmt = "#,##0";
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
}
